<template>
    <OtherDealsPopup />
    <PopupDialog />
    <ConfirmPopup />
    <div class="layout" :class="{ '_overflow-clear': overflowClear }">
        <router-view />
    </div>
    <p-toast />
    <app-fullscreen-spinner />
    <app-company-status-dialog />
</template>
<script lang="ts">
import { AppComponent } from "./app.ts";
export default AppComponent;
</script>
